import { _request, APIMethod } from '..';

import * as apiTypes from './LicenseUserGroupsApiTypeDefs';

const TENANTS_PATH_PREFIX = '/tenants';
const USER_GROUPS_PATH_PREFIX = 'usergroups';

export const APILicenseUserGroupsGet: APIMethod<apiTypes.APILicenseUserGroupsGetParams, apiTypes.APILicenseUserGroupsGetResponse> = params => {
    const apiPath = `${TENANTS_PATH_PREFIX}/${params.tenantId}/${USER_GROUPS_PATH_PREFIX}`;
    const licenseQuery = `&licenseId=${params.licenseId}`;
    return _request('GET', `${apiPath}?${licenseQuery}&licenseFilterType=SpecificLicense`, undefined, params.signal);
};
